<template>
  <div class="popup-parcelamento">
    <div v-if="boleto.atualizarVencimento">
      <div class="row">
        <div class="sm-12">
          <p>Boleto vencido.</p>
          <p>Caso queira uma segunda via, altere a data de vencimento.</p>
        </div>
        <!--{{ boleto.atualizarVencimento }}-->
      </div>
      <div class="row">
        <div class="sm-12">
          <p>
            Ao confirmar a atualização da data de vencimento do seu boleto, o
            mesmo vai ser atualizado.
            <br />Esta alteração poderá gerar multas, juros e encargos.
          </p>
        </div>
      </div>
      <form @submit.prevent.stop="atualizarVencimento">
        <div class="row">
          <div class="sm-12 md-6">
            <!--<input
                            type="date"
                            lang="pt"
                            v-model="data"
                            v-if="boleto.atualizarVencimento"
                            :min="hoje"
                            />
                        -->

            <datetime
              v-model="Data"
              :use-utc="true"
              zone-value="America/Sao_Paulo"
              zone="America/Sao_Paulo"
              type="date"
              format="dd/LL/yyyy"
              :min-datetime="Hoje"
              v-if="boleto.atualizarVencimento"></datetime>
          </div>
          <div class="sm-12 md-6">
            <button disabled v-if="sending" class="button secondary full">
              Confirmando...
            </button>
            <button type="submit" v-else class="button secondary full">
              Confirmar atualização
            </button>
          </div>
        </div>
      </form>
    </div>
    <div v-else>
      <!--
                <div class="tabs">
                    <button
                    class="default-button full"
                    @click="activeTab='boleto'"
                    :class="{active: activeTab == 'boleto'}"
                    >BOLETO</button>
                    <button
                    class="default-button full"
                    @click="activeTab='parcelamento'"
                    :class="{active: activeTab == 'parcelamento'}"
                    >SIMULAR PARCELAMENTO</button>
                </div>
            -->
      <div>
        <div class="row">
          <div class="sm-12 md-6">
            <download-link
              :href="url"
              target="_system"
              class="button secondary full"
              >Baixar boleto</download-link
            >
          </div>
          <div class="sm-12 md-6">
            <button class="button secondary full" v-if="sending">
              Enviando...
            </button>
            <button class="button secondary full" v-else @click="enviarEmail">
              Enviar por e-mail
            </button>
          </div>
        </div>
        <div class="row">
          <div class="sm-12 md-6">
            <button
              class="button secondary full"
              @click="copiarCodigoBarras"
              v-if="resultadoCodigoDeBarras && resultadoCodigoDeBarras.success">
              Copiar código de barras
            </button>
          </div>
          <div class="sm-12 md-6">
            <button
              class="button secondary full"
              @click="copiarCodigoqr"
              v-if="resultadoCodigoQR && resultadoCodigoQR.success">
              Copiar QR CODE
            </button>
          </div>
        </div>
        <div class="row">
          <div class="sm-12">
            <p>&nbsp;</p>
            <p
              class="text-center"
              v-if="constantes.SEGUNDA_VIA_AVISO_TEMPO_PAGAMENTO"
              v-html="constantes.SEGUNDA_VIA_AVISO_TEMPO_PAGAMENTO"></p>
            <p>&nbsp;</p>
          </div>
        </div>
      </div>
      <button
        class="button secondary full"
        @click="showParcelamento = !showParcelamento"
        :class="{ active: activeTab == 'parcelamento' }">
        Simular parcelamento
      </button>
      <div v-if="showParcelamento">
        <Parcelamento :boleto="boleto"></Parcelamento>
        <!--
                -->
      </div>
      <center>
        <button class="button" @click.prevent.stop="$emit('close')">
          Fechar
        </button>
      </center>
    </div>
  </div>
</template>
<script>
import { DateTime } from "luxon";
import api from "/plugins/api";
import Swal from "sweetalert2";
import qs from "qs";

import Parcelamento from "./parcelamento.vue";
import { api_endpoint } from "~/plugins/api";
export default {
  props: ["boleto"],
  components: {
    Parcelamento,
  },
  data() {
    return {
      data: DateTime.local().toFormat("yyyy-LL-dd"),
      hoje: DateTime.local().toFormat("yyyy-LL-dd"),
      Hoje: DateTime.local().toISO(),
      activeTab: "boleto",
      showParcelamento: false,
      sending: false,
      errors: [],
      constantes: {},
      resultadoCodigoDeBarras: null,
      resultadoCodigoQR: null,
    };
  },
  computed: {
    Data: {
      get() {
        return DateTime.fromSQL(this.data).toISO();
      },
      set(v) {
        let data = DateTime.fromISO(v, { zone: "UTC" }).toFormat("yyyy-LL-dd");
        this.data = data;
      },
    },
    codigo() {
      return this.boleto.codigo;
    },
    cliente() {
      return this.$store.state.cliente;
    },
    mes() {
      return this.$route.params.mes;
    },
    ano() {
      return this.$route.params.ano;
    },
    relacao() {
      return this.$store.getters.relacao;
    },
    condominio() {
      return this.$store.getters.condominio;
    },
    imovel() {
      return this.$store.getters.imovel;
    },
    jwt() {
      return this.$store.state.jwt;
    },
    maior_dia_util() {
      let vencimento = DateTime.fromSQL(this.boleto.dataVencimento);
      let dias_mes = vencimento.daysInMonth;
      let ultimo_dia_mes = DateTime.fromSQL(
        vencimento.toFormat(`yyyy-LL-${dias_mes}`)
      );

      let subtrair = 0;
      if (ultimo_dia_mes.weekday == 1) {
        subtrair = 2;
      } else if (ultimo_dia_mes == 7) {
        subtrair = 1;
      }
      if (subtrair > 0) {
        ultimo_dia_mes.plus({
          days: -subtrair,
        });
      }
      return ultimo_dia_mes.toFormat("yyyy-LL-dd");
    },
    url() {
      let tipo = this.relacao.sistema == "C" ? "condominio" : "aluguel";
      let tipo_relacao = this.relacao.tipoRelacao;

      let query = {
        jwt: this.jwt,
        atualizarVencimento: this.boleto.atualizarVencimento,
      };
      if (this.data != this.boleto.dataVencimento) {
        query.data_vencimento = this.data;
      }
      query = qs.stringify(query);

      //let endpoint = `${location.origin}${location.pathname}api`;
      let endpoint = api_endpoint;
      if (
        location.origin == "file://" ||
        "undefined" != typeof window.cordova
      ) {
        endpoint = window.api_endpoint;
      }

      return `${endpoint}/boletos/${tipo}/${tipo_relacao}/${this.codigo}?${query}`;
    },
    codigobarras() {
      let tipo = this.relacao.sistema == "C" ? "condominio" : "aluguel";
      let tipo_relacao = this.relacao.tipoRelacao;

      let query = {
        jwt: this.jwt,
      };
      query = qs.stringify(query);

      //let endpoint = `${location.origin}${location.pathname}api`;
      let endpoint = api_endpoint;
      if (
        location.origin == "file://" ||
        "undefined" != typeof window.cordova
      ) {
        endpoint = window.api_endpoint;
      }

      return `${endpoint}/consulta-boleto/${tipo}/${tipo_relacao}/${this.codigo}?${query}`;
    },
    codigoqr() {
      let tipo = this.relacao.sistema == "C" ? "condominio" : "aluguel";
      let tipo_relacao = this.relacao.tipoRelacao;

      let query = {
        jwt: this.jwt,
      };
      query = qs.stringify(query);

      //let endpoint = `${location.origin}${location.pathname}api`;
      let endpoint = api_endpoint;
      if (
        location.origin == "file://" ||
        "undefined" != typeof window.cordova
      ) {
        endpoint = window.api_endpoint;
      }

      return `${endpoint}/consulta-boleto/${tipo}/qrcode/${tipo_relacao}/${this.codigo}?${query}`;
    },
  },
  async mounted() {
    await this.obterCodigoDeBarras();
    await this.obterCodigoQR();
  },
  methods: {
    async loadConstantes() {
      let { data } = await api.get("/constantes");
      this.constantes = data.reduce((acc, row) => {
        acc[row.chave] = row.valor;
        return acc;
      }, {});
    },
    async verificaData(e) {
      try {
        if (this.data < this.hoje || this.data > this.maior_dia_util) {
          let hoje = DateTime.fromSQL(this.hoje).toFormat("dd/LL/yyyy");
          let ultimo = DateTime.fromSQL(this.maior_dia_util).toFormat(
            "dd/LL/yyyy"
          );
          if (hoje > ultimo) {
            hoje = DateTime.fromSQL(this.maior_dia_util).toFormat("01/LL/yyyy");
          }
          /*
                    throw new Error(
                    `A data de vencimento do seu boleto,\ndeve ser entre ${hoje} e ${ultimo}`
                    );
                    */
        }

        if (this.data != this.boleto.dataVencimento) {
          if (
            !confirm(
              "=====TELA DE CONFIRMAÇÃO=====\n\nCaso você confirme a atualização da\ndata de vencimento do seu boleto, o\nmesmo vai ser atualizado.\n\nEsta alteração poderá gerar multas,\n juros e encargos.\n\nConfirmar atualização?"
            )
          ) {
            if (e) {
              e.preventDefault();
              e.stopPropagation();
            }
            return false;
          }
        }

        return true;
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Oops",
          text: err.message,
          didClose: () => {
            this.$emit("close");
          },
        });
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
      return false;
    },
    async atualizarVencimento() {
      try {
        /*
                let { isConfirmed } = await Swal.fire({
                    icon: "warning",
                    title: "Aviso",
                    html: `<p class="text-center">Caso você confirme a atualização da 
                        data de vencimento do seu boleto, o 
                        mesmo vai ser atualizado.<br />
                        Esta alteração poderá gerar multas,
                        juros e encargos.
                        <br /><br />Confirmar atualização?</p>`,
                        showCancelButton: true,
                        cancelButtonText: "Não",
                        confirmButtonText: "Sim"
                    });
                    
                    if (!isConfirmed) {
                        this.$emit('close');
                        return;
                    }
                    */

        let tipo = this.relacao.sistema == "C" ? "condominio" : "aluguel";
        let tipo_relacao = this.relacao.tipoRelacao;

        let params = {};
        if (this.data != this.boleto.dataVencimento) {
          params.data_vencimento = this.data;
        }

        this.sending = true;

        let { data } = await api.post(
          `boletos/${tipo}/${tipo_relacao}/${this.codigo}/alterar-vencimento`,
          params
        );
        Swal.fire({
          icon: "success",
          title: "Sucesso",
          text: `Vencimento alterado com sucesso!`,
          didClose: () => {
            this.$emit("close");
          },
        });
        this.$emit("updated", this.boleto);
      } catch (err) {
        if (err.response && err.response.data) {
          alert(err.response.data.error);
          /*
                    Swal.fire({
                        icon: "error",
                        title: "Oops",
                        text: err.response.data.error,
                        didClose: () => {
                            this.$emit("close");
                        }
                    });
                    */
        } else {
          alert("Não foi possível alterar o vencimento do boleto.");
          /*
                    Swal.fire({
                        icon: "error",
                        title: "Oops",
                        text: "Não foi possível alterar o vencimento do boleto",
                        didClose: () => {
                            this.$emit("close");
                        }
                    });
                    */
        }
        console.error(err);
      }
      this.sending = false;
    },
    async enviarEmail() {
      try {
        /*
                if (!this.verificaData()) {
                    return;
                }
                */

        let tipo = this.relacao.sistema == "C" ? "condominio" : "aluguel";
        let tipo_relacao = this.relacao.tipoRelacao;

        let params = {};

        params.data_vencimento = this.boleto.dataVencimento;

        this.sending = true;
        let { data } = await api.post(
          `boletos/${tipo}/${tipo_relacao}/${this.codigo}`,
          params
        );
        Swal.fire({
          icon: "success",
          title: "Sucesso",
          text: `Boleto enviado para o e-mail: ${this.cliente.contato.email}`,
          didClose: () => {
            this.$emit("close");
          },
        });
      } catch (err) {
        if (err.response && err.response.data) {
          Swal.fire({
            icon: "error",
            title: "Oops",
            text: err.response.data.error,
            didClose: () => {
              this.$emit("close");
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops",
            text: "Não foi possível enviar o boleto",
            didClose: () => {
              this.$emit("close");
            },
          });
        }
        console.error(err);
      }
      this.sending = false;
    },
    async obterCodigoDeBarras() {
      try {
        const url = this.codigobarras; // Remova os parênteses
        const response = await fetch(url);

        if (response.ok) {
          const data = await response.json(); // Se a resposta for JSON
          this.resultadoCodigoDeBarras = data;
        } else {
          console.error("Erro ao obter dados:", response.statusText);
          this.resultadoCodigoDeBarras = null;
        }
      } catch (error) {
        console.error("Erro na requisição:", error.message);
        this.resultadoCodigoDeBarras = null;
      }
    },
    copiarCodigoBarras() {
      if (
        this.resultadoCodigoDeBarras &&
        this.resultadoCodigoDeBarras.success
      ) {
        const codigoBarras = this.resultadoCodigoDeBarras.codigo;

        const inputElement = document.createElement("input");
        inputElement.value = codigoBarras;

        document.body.appendChild(inputElement);

        inputElement.select();
        inputElement.setSelectionRange(0, 99999); // Para dispositivos móveis

        document.execCommand("copy");

        document.body.removeChild(inputElement);

        alert("Código de barras copiado para a área de transferência!");
      }
    },

    async obterCodigoQR() {
      try {
        const url = this.codigoqr; // Remova os parênteses
        const response = await fetch(url);

        if (response.ok) {
          const data = await response.json(); // Se a resposta for JSON
          this.resultadoCodigoQR = data;
        } else {
          console.error("Erro ao obter dados:", response.statusText);
          this.resultadoCodigoQR = null;
        }
      } catch (error) {
        console.error("Erro na requisição:", error.message);
        this.resultadoCodigoQR = null;
      }
    },

    copiarCodigoqr() {
      if (this.resultadoCodigoQR && this.resultadoCodigoQR.success) {
        const codigoqr = this.resultadoCodigoQR.codigo;

        const inputElement = document.createElement("input");
        inputElement.value = codigoqr;

        document.body.appendChild(inputElement);

        inputElement.select();
        inputElement.setSelectionRange(0, 99999); // Para dispositivos móveis

        document.execCommand("copy");

        document.body.removeChild(inputElement);

        alert("QR CODE copiado para a área de transferência!");
      }
    },
  },
  created() {
    this.loadConstantes();
  },
};
</script>
<style lang="less">
.swal2-popup {
  width: 60em !important;
  max-width: 100vw !important;
}
</style>
<style lang="less" scoped>
.tabs {
  display: flex;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;
    margin: 1px;
    opacity: 0.7;
    &.active {
      opacity: 1;
    }
  }
}
</style>
